import {
  RetailUnitSchema,
  LotteryConfigSchema,
  LotterySchema,
  TranslationConfigSchema,
} from '@lotta/shared/types-lottery-schemas';
import type { Static } from '@sinclair/typebox';
import { Type } from '@sinclair/typebox';

export type UpdateLotteryParams = Static<typeof UpdateLotteryParamsSchema>;
export const UpdateLotteryParamsSchema = Type.Object(
  {
    retailUnit: RetailUnitSchema.properties.id,
    lotteryId: LotterySchema.properties.id,
  },
  { additionalProperties: false, $id: 'UpdateLotteryParamsSchema' }
);

export type UpdateLotteryBody = Static<typeof UpdateLotteryBodySchema>;
export const UpdateLotteryBodySchema = Type.Object(
  {
    lottery: LotteryConfigSchema,
    translation: TranslationConfigSchema,
  },
  { additionalProperties: false, $id: 'UpdateLotteryBodySchema' }
);

export type UpdateLotteryResponse = Static<typeof UpdateLotteryResponseSchema>;
export const UpdateLotteryResponseSchema = Type.Object(
  {
    id: LotterySchema.properties.id,
  },
  { additionalProperties: false, $id: 'UpdateLotteryResponseSchema' }
);
